import baseAPI from '@/http'

const router = 'api/municipio/municipiosolucao'

export const citySolutionAPI = {
  create: (citySolution) => baseAPI.post(router, citySolution),
  update: (citySolution) => baseAPI.put(router, citySolution),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  list: () => baseAPI.get(router),
  get: (id) => baseAPI.get(`${router}/${id}`),
  listByCity: (filter) => baseAPI.post(`${router}/list-by-municipio`, filter),
  getByCity: (id) => baseAPI.get(`${router + '/get-by-permissao-municipio'}/${id}`),
  getReadyToFinish: (id) => baseAPI.get(`${router + '/solucoes-a-finalizar'}/${id}`),
  finishSolutions: (solutions) => baseAPI.post(`${router + '/finalizar-solucoes'}`, solutions),
  solutionStarted: (solution) => baseAPI.post(`${router + '/solucao-iniciada'}`, solution),
  addByGrupoSolucao: (grupoSolucao) => baseAPI.post(`${router + '/add-by-grupo-solucao'}`, grupoSolucao),
  verifyHoursSolution: (municipioTarefas, municipiosolucaoid) => baseAPI.post(`${router}/verificar-tarefa/${municipioTarefas}/${municipiosolucaoid}`)

}
